<template>
  <div>
    <div class="mb-2">
      <slot name="description"></slot>
    </div>
    <div class="d-flex p-3">
      <AppButton
        block
        variant="outline-dark"
        @click="onClickDecline"
        class="button mr-1"
        id="decline-button"
      >
        {{ declineText }}
      </AppButton>
      <AppButton
        block
        @click="onClickAccept"
        :variant="acceptButtonVariant"
        class="button"
        id="accept-button"
      >
        {{ acceptText }}
      </AppButton>
    </div>
  </div>
</template>

<script lang="ts">
import AppButton from "@/components/atoms/button/AppButton.vue";
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  components: {
    AppButton
  }
})
export default class ModalPage extends Vue {
  @Prop({
    required: true,
    type: String
  })
  acceptText!: string;

  @Prop({
    required: true,
    type: String
  })
  declineText!: string;

  @Prop({
    required: false,
    type: String,
    default: "primary"
  })
  acceptButtonVariant!: string;

  onClickAccept() {
    this.$emit("accept");
  }

  onClickDecline() {
    this.$emit("decline");
  }
}
</script>

<style lang="scss" scoped>
.button {
  margin-top: 0; // AppButtonが2つ並ぶと自動でmargin-topがついてしまうので、それを無効化
}
</style>
